import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import CornerWeatherPreviewPortrait from '../../SharedComponents/Weather/Previews/Corner/CornerWeatherPreviewPortrait';
import { Spinner } from 'react-bootstrap';
import { useReadWeatherExternal } from '../../../queries/weather';
import CornerWeatherPreview from '../../SharedComponents/Weather/Previews/Corner/CornerWeatherPreview';
import { setWeatherBgColor, setWeatherTextColor } from '../../../redux/Slices/Apps/appsSlice';
import { useDispatch, useSelector } from 'react-redux';

function useQuery() {
    return new URLSearchParams(useLocation().search);
}
const defaultArea = {
    start_margin: 0,
    top_margin: 0,
    width: 35,
    height: 37,
    layout: "landscape-wide"
};

function CornerWeather() {
    const query = useQuery();
    const [isLandscape, setIsLandscape] = useState(window.innerWidth > window.innerHeight);
    const { weatherTextColor } = useSelector(state => state.apps);
    const dispatch = useDispatch()
    const id = query.get('id');
    const access_token = query.get('token');
    const [area, setArea] = useState(defaultArea);

    const payload = { media_id: id, token: access_token };

    const { data, isLoading, isError } = useReadWeatherExternal(payload);
    useEffect(() => {
        document.body.classList.add('transparent-body');
        const handleResize = () => {
            const ratio = window.innerWidth / window.innerHeight;
            setIsLandscape(ratio > 1.2);

        };

        window.addEventListener('resize', handleResize);
        handleResize();

        return () => {
            document.body.classList.remove('transparent-body');
            window.removeEventListener('resize', handleResize);
        }
    }, []);


    useEffect(() => {
        setArea(data?.media?.weather?.settings?.corner_setting || defaultArea)
        dispatch(setWeatherTextColor(data?.media?.weather?.settings?.textColor))
 
    }, [data]);

    if (isLoading && !data) {
        return (
            <div className="h-[100vh] w-[100vw] flex justify-center items-center">
                <Spinner variant="primary" animation="border" size="lg" className="m-3" />
            </div>
        );
    }

    if (isError) {
        return <div className="m-3 text-danger">Error loading weather data.</div>;
    }

    return (
        <div style={{ width: '100vw', height: '100vh' }}>
            
            {isLandscape ? (
                <CornerWeatherPreview area={area} setArea={setArea} data={data} previewMode={false} />
            ) : (
                <CornerWeatherPreviewPortrait area={area} setArea={setArea} data={data} previewMode={false} />
            )}
        </div>
    );
}

export default CornerWeather;
